import _defineProperty from "E:\\01_WORK\\02_ClearTicket\\clearticket_pc\\node_modules\\@babel\\runtime-corejs2/helpers/esm/defineProperty";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
import { on, off } from "./dom";
var prefixCls = 'ivu-affix';

function getScroll(target, top) {
  var prop = top ? 'pageYOffset' : 'pageXOffset';
  var method = top ? 'scrollTop' : 'scrollLeft';
  var ret = target[prop];

  if (typeof ret !== 'number') {
    ret = window.document.documentElement[method];
  }

  return ret;
}

function getOffset(element) {
  var rect = element.getBoundingClientRect();
  var scrollTop = getScroll(window, true);
  var scrollLeft = getScroll(window);
  var docEl = window.document.body;
  var clientTop = docEl.clientTop || 0;
  var clientLeft = docEl.clientLeft || 0;
  return {
    top: rect.top + scrollTop - clientTop,
    left: rect.left + scrollLeft - clientLeft
  };
}

export default {
  name: 'Affix',
  props: {
    wrap: {
      type: HTMLBodyElement,
      default: function _default() {
        return document.body;
      }
    },
    offsetTop: {
      type: Number,
      default: 0
    },
    offsetBottom: {
      type: Number
    },
    useCapture: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      affix: false,
      styles: {},
      slot: false,
      slotStyle: {}
    };
  },
  computed: {
    offsetType: function offsetType() {
      var type = 'top';

      if (this.offsetBottom >= 0) {
        type = 'bottom';
      }

      return type;
    },
    classes: function classes() {
      return [_defineProperty({}, "".concat(prefixCls), this.affix)];
    }
  },
  mounted: function mounted() {
    var _this = this;

    //            window.addEventListener('scroll', this.handleScroll, false);
    //            window.addEventListener('resize', this.handleScroll, false);
    on(window, 'scroll', this.handleScroll, this.useCapture);
    on(window, 'resize', this.handleScroll, this.useCapture);
    this.$nextTick(function () {
      _this.handleScroll();
    });
  },
  beforeDestroy: function beforeDestroy() {
    //            window.removeEventListener('scroll', this.handleScroll, false);
    //            window.removeEventListener('resize', this.handleScroll, false);
    off(window, 'scroll', this.handleScroll, this.useCapture);
    off(window, 'resize', this.handleScroll, this.useCapture);
  },
  methods: {
    handleScroll: function handleScroll() {
      var affix = this.affix;
      var scrollTop = getScroll(window, true);
      var elOffset = getOffset(this.$el);
      var windowHeight = window.innerHeight;
      var elHeight = this.$el.getElementsByTagName('div')[0].offsetHeight; // fix window resize

      if (affix) {
        this.styles = {
          top: "".concat(this.offsetTop, "px"),
          left: "".concat(elOffset.left, "px"),
          width: "".concat(this.$el.offsetWidth, "px")
        };
      } // Fixed Top


      if (elOffset.top - this.offsetTop < scrollTop && this.offsetType === 'top' && !affix) {
        this.affix = true;
        this.slotStyle = {
          width: this.$refs.point.clientWidth + 'px',
          height: this.$refs.point.clientHeight + 'px'
        };
        this.slot = true;
        this.styles = {
          top: "".concat(this.offsetTop, "px"),
          left: "".concat(elOffset.left, "px"),
          width: "".concat(this.$el.offsetWidth, "px")
        };
        this.$emit('on-change', true);
      } else if (elOffset.top - this.offsetTop >= scrollTop && this.offsetType === 'top' && affix) {
        this.slot = false;
        this.slotStyle = {};
        this.affix = false;
        this.styles = null;
        this.$emit('on-change', false);
      } // Fixed Bottom


      if (elOffset.top + this.offsetBottom + elHeight > scrollTop + windowHeight && this.offsetType === 'bottom' && !affix) {
        this.affix = true;
        this.styles = {
          bottom: "".concat(this.offsetBottom, "px"),
          left: "".concat(elOffset.left, "px"),
          width: "".concat(this.$el.offsetWidth, "px")
        };
        this.$emit('on-change', true);
      } else if (elOffset.top + this.offsetBottom + elHeight < scrollTop + windowHeight && this.offsetType === 'bottom' && affix) {
        this.affix = false;
        this.styles = null;
        this.$emit('on-change', false);
      }
    }
  }
};